export default __webpack_public_path__ + "static/media/sk-flag.2fb724d5.svg";